'use strict';

const getNavigator = () => (typeof window !== 'undefined' ? navigator : undefined);
const getUserAgent = () => getNavigator()?.userAgent ?? getNavigator()?.vendor;

exports.getNavigator = getNavigator;
exports.getUserAgent = getUserAgent;
//# sourceMappingURL=device.js.map
